const TOOLS_RETURN_PATH_KEY = 'toolsReturnPath';

/** Call when navigating into a tool so Back on the tool root can return here. */
export function rememberToolsReturnPath() {
  const path = `${window.location.pathname}${window.location.search}`;
  if (!path.startsWith('/tools')) {
    sessionStorage.setItem(TOOLS_RETURN_PATH_KEY, path);
  }
}

/** Leave a tool root view — return to pre-tools path, or the app home. */
export function exitToolView(history: {
  push: (path: string) => void;
  goBack: () => void;
}) {
  const returnPath = sessionStorage.getItem(TOOLS_RETURN_PATH_KEY);
  if (returnPath && !returnPath.startsWith('/tools')) {
    sessionStorage.removeItem(TOOLS_RETURN_PATH_KEY);
    history.push(returnPath);
    return;
  }
  history.push('/home');
}
